export default "__VITE_ASSET__Cnu4rLT4__"